import $ from "jquery";
import Cookies from "js-cookie";
import Sortable from "sortablejs";

import {
    addToCart,
    removeElemCart,
    removeAllCart,
    loadCart,
    showCart,
    addSales,
    loadSales,
    removeSales,
    removeAllSales,
    incElemCart,
    decElemCart,
    incElemList,
    decElemList,
    reorderCartFromDom,
    reindexCartFormItems,
} from "./utils";

const cart = () => {
    //добавление в корзину при клике на кнопку
    $(document).on("click", ".js-buy", function (e) {
        const target = e.currentTarget;

        addToCart(target);
    });

    //клик по счетчику на страницах каталога и внутренней странице товара
    $(document).on("click", ".js-count .count__btn.dec", function (e) {
        const target = e.currentTarget;
        let targetVal = +$(this).parent().find("input").val();

        $(this)
            .siblings("input")
            .val(targetVal - 1);

        // запись в Cookies
        decElemList(target);
    });

    $(document).on("click", ".js-count .count__btn.inc", function (e) {
        const target = e.currentTarget;
        let targetVal = +$(this).parent().find("input").val();

        $(this)
            .siblings("input")
            .val(targetVal + 1);

        // запись в Cookies
        incElemList(target);
    });

    $(".sale__input, .manual-price__input, .count__input").on(
        "keypress",
        function (e) {
            if (e.keyCode == 13) {
                return false;
            }
        }
    );

    if ($(".cart").length) {
        loadCart();

        if ($(".sale__input").length) {
            loadSales();
        }

        //разбиение числа на разряды
        function numberWithSpaces(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }

        //убираем из числе разряды
        function numberWithoutSpaces(x) {
            return x.toString().replace(/\s/g, "");
        }

        // разбиваем числа на разряды при загрузке
        $(".cart__table-item").each(function () {
            let price = parseInt(
                $(this).find(".price .curr").attr("data-value")
            );
            let oldPrice = parseInt(
                $(this).find(".price .old").attr("data-value")
            );

            $(this)
                .find(".price .curr")
                .html(`${numberWithSpaces(price)} &#8381;`);

            if ($(this).find(".manual-price").length) {
                const value = $(this)
                    .find(".manual-price .manual-price__input")
                    .val();

                $(this)
                    .find(".manual-price .manual-price__input")
                    .val(`${numberWithSpaces(value)}`);
            }

            if (price == oldPrice) {
                $(this).find(".price .old").hide();
                $(this).find(".manual-price .old").hide();
            } else {
                $(this)
                    .find(".price .old")
                    .show()
                    .html(`${numberWithSpaces(oldPrice)} &#8381;`);

                if ($(this).find(".manual-price").length) {
                    $(this)
                        .find(".manual-price .old")
                        .show()
                        .html(`${numberWithSpaces(oldPrice)} &#8381;`);
                }
            }
        });

        //функция подсчета цены
        function totalSum() {
            let total = 0;
            let totalOldPrice = 0;
            let totalSale = 0;

            $(".cart__table-item").each(function () {
                const price = $(this).find(".price .curr");
                const oldPrice = $(this).find(".price .old");
                const count = $(this).find(".count__input");

                const priceVal = parseInt(price.text().replace(/\s/g, ""));
                const oldPriceVal = parseInt(
                    oldPrice.text().replace(/\s/g, "")
                );
                const countVal = +count.val();

                const priceValSum = priceVal * countVal;
                const oldPriceValSum = oldPriceVal * countVal;

                totalOldPrice += oldPriceValSum;
                total += priceValSum;
            });

            totalSale = totalOldPrice - total;

            // hidden for order
            $(".cart__footer .price .hidden_sum").attr(
                "value",
                numberWithSpaces(total)
            );
            $(".cart__footer .price .hidden_sale").attr(
                "value",
                numberWithSpaces(totalSale)
            );

            $(".cart__footer .price .sum").text(numberWithSpaces(total));

            if (totalSale) {
                $(".cart__footer .price .sale").html(
                    `(Ваша скидка — ${numberWithSpaces(totalSale)} &#8381;)`
                );
            } else {
                $(".cart__footer .price .sale").html("");
            }
        }

        // Подсчитываем сумму при загрузке
        totalSum();

        function syncCartOrder() {
            reorderCartFromDom();
            reindexCartFormItems();
            updateCartSortButtons();
        }

        function updateCartSortButtons() {
            const $items = $(".cart__table_ul .cart__table-item");

            $items.each(function (idx) {
                $(this)
                    .find(".js-cart-sort-up")
                    .toggleClass("disabled", idx === 0)
                    .prop("disabled", idx === 0);
                $(this)
                    .find(".js-cart-sort-down")
                    .toggleClass("disabled", idx === $items.length - 1)
                    .prop("disabled", idx === $items.length - 1);
            });
        }

        if ($(".cart__table_ul").length) {
            updateCartSortButtons();

            const sortContainer =
                $(".cart__table_ul tbody")[0] || $(".cart__table_ul")[0];

            Sortable.create(sortContainer, {
                handle: ".js-cart-sort-handle",
                draggable: ".cart__table-item",
                animation: 150,
                onEnd: syncCartOrder,
            });

            $(document).on("click", ".js-cart-sort-up", function (e) {
                e.preventDefault();

                if ($(this).hasClass("disabled")) {
                    return;
                }

                const $row = $(this).closest(".cart__table-item");
                const $prev = $row.prev(".cart__table-item");

                if ($prev.length) {
                    $row.insertBefore($prev);
                    syncCartOrder();
                }
            });

            $(document).on("click", ".js-cart-sort-down", function (e) {
                e.preventDefault();

                if ($(this).hasClass("disabled")) {
                    return;
                }

                const $row = $(this).closest(".cart__table-item");
                const $next = $row.next(".cart__table-item");

                if ($next.length) {
                    $row.insertAfter($next);
                    syncCartOrder();
                }
            });
        }

        // прописывание скидки у Юр. лиц
        function customSales() {
            $(".cart__table-item").each(function () {
                const price = parseInt(
                    $(this).find(".price .curr").attr("data-value")
                );

                const oldPrice = parseInt(
                    $(this).find(".price .old").attr("data-value")
                );
                const sale = $(this).find(".sale .sale__input").val();

                const manualPrice = parseInt(
                    numberWithoutSpaces(
                        $(this).find(".manual-price .manual-price__input").val()
                    )
                );

                if (sale) {
                    // let oldPrice = price;
                    const rawPrice = manualPrice - manualPrice * (+sale / 100);
                    const newPrice = Math.round(rawPrice);

                    $(this)
                        .find(".price .curr")
                        .html(`${numberWithSpaces(newPrice)} &#8381;`);

                    $(this)
                        .find(".price .old")
                        .show()
                        .html(`${numberWithSpaces(oldPrice)} &#8381;`);

                    // столбец с инпутом
                } else if (manualPrice != price) {
                    $(this).find(".sale .sale__input").val("");

                    const newPrice = manualPrice;

                    $(this)
                        .find(".price .curr")
                        .html(`${numberWithSpaces(newPrice)} &#8381;`);

                    $(this)
                        .find(".price .old")
                        .show()
                        .html(`${numberWithSpaces(oldPrice)} &#8381;`);
                } else {
                    $(this)
                        .find(".price .curr")
                        .html(`${numberWithSpaces(price)} &#8381;`);

                    // если скидки изначально не было
                    if (price == oldPrice) {
                        $(this)
                            .find(".price .old")
                            .hide()
                            .html(`${numberWithSpaces(oldPrice)} &#8381;`);

                        // столбец с инпутом
                        $(this)
                            .find(".manual-price .old")
                            .hide()
                            .html(`${numberWithSpaces(oldPrice)} &#8381;`);
                    } else {
                        $(this)
                            .find(".price .old")
                            .show()
                            .html(`${numberWithSpaces(oldPrice)} &#8381;`);
                    }
                }
            });

            $(".price").removeClass("inactive");

            totalSum();
        }

        // запрет на ввод больше 100% в скидку
        $(".sale .sale__input").on("input", function () {
            $(this).val(
                $(this)
                    .val()
                    .replace(/[^\d]+/g, "")
            );

            if (+$(this).val() > 100) {
                $(this).val("100");
            }
        });

        // действия при потере фокуса на скидке
        $(".sale .sale__input").blur(function () {
            if ($(this).val()) {
                $(this)
                    .closest(".cart__table-item")
                    .find(".manual-price__input")
                    .addClass("inactive");
            } else {
                $(this)
                    .closest(".cart__table-item")
                    .find(".manual-price__input")
                    .removeClass("inactive");
            }
        });

        // запрет на ввод букв в инпут
        $(".manual-price .manual-price__input").on("input", function () {
            $(this).val(
                $(this)
                    .val()
                    .replace(/[^\d]+/g, "")
            );

            if (+$(this).val() > +$(this).attr("data-value")) {
                $(this).val($(this).attr("data-value"));
            }
        });

        // убираем пробелы в инпуте при фокусе
        $(".manual-price .manual-price__input").on("focus", function () {
            $(this).val(numberWithoutSpaces($(this).val()));
        });

        // действия при потере фокуса
        $(".manual-price .manual-price__input").blur(function () {
            const price = parseInt($(this).attr("data-value"));
            const newPrice = parseInt($(this).val());

            // убираем пробелы
            $(this).val(numberWithSpaces($(this).val()));

            // меняем активность у инпута скидки
            if (price != newPrice) {
                $(this)
                    .closest(".cart__table-item")
                    .find(".sale__input")
                    .addClass("inactive");
            } else {
                $(this)
                    .closest(".cart__table-item")
                    .find(".sale__input")
                    .removeClass("inactive");
            }
        });

        // кнопка "Пересчитать со скидкой"
        $(".cart__footer .calc").on("click", function () {
            addSales();
            customSales();
        });

        //чекбокс кредита
        $('input[name="credit"]').on("change", function () {
            if ($(this).is(":checked")) {
                $(".btns .order")
                    .addClass("js-popup-open btn-credit")
                    .attr("data-type", "credit")
                    .text("Купить в рассрочку");
            } else {
                $(".btns .order")
                    .removeClass("js-popup-open btn-credit")
                    .removeAttr("data-type")
                    .text("Оформить заказ");
            }
        });

        // уменьшение количества товара
        $(".count__btn.dec").on("click", function (e) {
            const target = e.currentTarget;
            let targetVal = +$(this).parent().find("input").val();

            if (targetVal > 1) {
                $(this)
                    .siblings("input")
                    .val(targetVal - 1);

                // запись в Cookies
                decElemCart(target);

                //пересчет суммы
                totalSum();
            }
        });

        // увеличение колличества товара
        $(".count__btn.inc").on("click", function (e) {
            const target = e.currentTarget;
            let targetVal = +$(this).parent().find("input").val();

            $(this)
                .siblings("input")
                .val(targetVal + 1);

            // запись в Cookies
            incElemCart(target);

            //пересчет суммы
            totalSum();
        });

        //Удаление товара
        $(".js-cart-remove").on("click", function (e) {
            const target = e.currentTarget;

            // Запись в куки
            removeElemCart(target);

            $(this).closest(".cart__table-item").remove();

            showCart();

            //проверяем остались ли товары в корзине
            checkItems();

            //пересчет суммы
            totalSum();

            removeSales(target);

            if ($(".cart__table_ul").length) {
                reindexCartFormItems();
                updateCartSortButtons();
            }
        });

        // Добавление комментария к товару
        $(".js-comment-toggle").on("click", function (e) {
            $(this).toggleClass("active");
            $(this).next().toggleClass("active");

            if (!$(this).hasClass("active")) {
                $(this).next().val("");
            }
        });

        function checkItems() {
            if (!$(".cart__table-item").length) {
                removeAll();
                removeAllSales();
            }
        }

        //Удалить всё
        $(".js-cart-remove_all").on("click", function (e) {
            // запись в куки
            removeAllCart();
            showCart();
            removeAll();
            removeAllSales();
        });

        function removeAll() {
            $(".cart__table").remove();
            $(".js-cart-remove_all").remove();
            $(".cart__footer .btns").remove();

            $(".cart__footer .price .result").text("Корзина пуста");
        }
    }
};

export default cart;
